export const state = {
    data: null,
    vGroups: []
}

export const mutations = {
    SET_DATA(state, payload) {
        state.data = payload.access
        payload.groups.forEach(row => {
            row.vgroups.forEach(v => {
                const x = state.vGroups.filter(y => y.id == v.id)
                if (!x.length) {
                    state.vGroups.push(v)
                }
            });
        });
    }
}
